import { useEffect, useRef, useCallback } from 'react';

export const useDebounce = <T>(
  value: T,
  delay: number,
  callback: (debouncedValue: T) => void
) => {
  const previousValue = useRef(value);
  const memoizedCallback = useCallback(callback, [callback]);

  useEffect(() => {
    if (value === previousValue.current) return;

    const handler = setTimeout(() => {
      previousValue.current = value;
      memoizedCallback(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [previousValue.current, delay, memoizedCallback]);
};
